import { Button } from '@/components/ui/button';
import { Download } from 'lucide-react';
import { useCollection } from '@/hooks/useCollection';
import { toast } from 'sonner';

function escapeCsv(v: string | number | null | undefined): string {
  if (v == null) return '';
  const s = String(v);
  return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
}

/**
 * One-click CSV export of the signed-in user's collection.
 * Format is import-friendly (name, subtitle, set, treatment, qty, print id).
 */
export function ExportCollectionButton() {
  const { data: items = [] } = useCollection();

  const handle = () => {
    if (!items.length) {
      toast.info('Nothing to export yet');
      return;
    }
    const header = ['name', 'subtitle', 'set', 'rarity', 'treatment', 'quantity', 'price_usd', 'card_id', 'print_id'];
    const rows = items.map(it => [
      it.card?.name ?? '',
      it.card?.subtitle ?? '',
      it.card?.set_name ?? '',
      it.card?.rarity ?? '',
      it.print?.treatment ?? '',
      it.quantity ?? 1,
      it.print?.price_usd ?? '',
      it.card_id,
      it.print_id ?? '',
    ].map(escapeCsv).join(','));
    const csv = [header.join(','), ...rows].join('\n');
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `lorescout-collection-${new Date().toISOString().slice(0, 10)}.csv`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
    toast.success(`Exported ${items.length} rows`);
  };

  return (
    <Button variant="outline" size="sm" onClick={handle} className="gap-1.5">
      <Download className="h-3.5 w-3.5" /> Export CSV
    </Button>
  );
}
